import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Ripple } from 'primereact/ripple';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';

const DataTablePM = ({
  className = null,
  rowClassName = null,
  value = null,
  columns = null,
  progressBarJobStatus = null,
  staticColumns = null,
  dataKey = null,
  header = null,
  showCheckbox = null,
  loading = null,
  showGridlines = true,
  sortMode = null,
  removableSort = true,
  sortMeta = null,
  handleSort = null,
  paginator = false,
  paginatorTemplate = null,
  currentPageReportTemplate = null,
  paginatorLeft = null,
  rows = null,
  rowsPerPageOptions = null,
  filterDisplay = null,
  emptyMessage = null,
  selection = null,
  selectionMode = null,
  resizableColumns = false,
  columnResizeMode = null,
  responsiveLayout = null,
  onSelectionChange = null,
  scrollable = false,
}) => {
  DataTablePM.propTypes = {
    className: PropTypes.string,
    rowClassName: PropTypes.any,
    value: PropTypes.array,
    columns: PropTypes.array,
    progressBarJobStatus: PropTypes.any,
    staticColumns: PropTypes.any,
    dataKey: PropTypes.string,
    header: PropTypes.any,
    showCheckbox: PropTypes.bool,
    loading: PropTypes.bool,
    showGridlines: PropTypes.bool,
    sortMode: PropTypes.string,
    removableSort: PropTypes.bool,
    sortMeta: PropTypes.any,
    handleSort: PropTypes.func,
    paginator: PropTypes.bool,
    paginatorTemplate: PropTypes.any,
    currentPageReportTemplate: PropTypes.any,
    paginatorLeft: PropTypes.any,
    rows: PropTypes.number,
    rowsPerPageOptions: PropTypes.array,
    filterDisplay: PropTypes.string,
    emptyMessage: PropTypes.string,
    selection: PropTypes.any,
    selectionMode: PropTypes.string,
    resizableColumns: PropTypes.bool,
    columnResizeMode: PropTypes.string,
    responsiveLayout: PropTypes.string,
    onSelectionChange: PropTypes.func,
    scrollable: PropTypes.bool,
  };

  const paginatorDefaultTemplate = {
    layout: 'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
    FirstPageLink: options => {
      let className = classNames(options.className, { 'paginator-font': true });
      return (
        <button type="button" className={className} onClick={options.onClick} disabled={options.disabled}>
          <span className="p-paginator-icon pi pi-angle-double-left" />
          <Ripple />
        </button>
      );
    },
    PrevPageLink: options => {
      let className = classNames(options.className, { 'paginator-font': true });
      return (
        <button type="button" className={className} onClick={options.onClick} disabled={options.disabled}>
          <span className="p-paginator-icon pi pi-angle-left" />
          <Ripple />
        </button>
      );
    },
    PageLinks: options => {
      let className = classNames(options.className, { 'paginator-font': true });
      return (
        <button type="button" className={className} onClick={options.onClick} disabled={options.disabled}>
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    NextPageLink: options => {
      let className = classNames(options.className, { 'paginator-font': true });
      return (
        <button type="button" className={className} onClick={options.onClick} disabled={options.disabled}>
          <span className="p-paginator-icon pi pi-angle-right" />
          <Ripple />
        </button>
      );
    },
    LastPageLink: options => {
      let className = classNames(options.className, { 'paginator-font': true });
      return (
        <button type="button" className={className} onClick={options.onClick} disabled={options.disabled}>
          <span className="p-paginator-icon pi pi-angle-double-right" />
          <Ripple />
        </button>
      );
    },
    RowsPerPageDropdown: options => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 15, value: 15 },
        { label: 45, value: 45 },
      ];

      return (
        <Dropdown className="paginator-font" style={{ width: '50px' }} value={options.value} options={dropdownOptions} onChange={options.onChange} />
      );
    },
  };

  return (
    <DataTable
      className={className}
      rowClassName={rowClassName}
      value={value}
      dataKey={dataKey}
      header={header}
      loading={loading}
      showGridlines={showGridlines}
      sortMode={sortMode}
      removableSort={removableSort}
      multiSortMeta={sortMeta}
      onSort={handleSort}
      paginator={paginator}
      paginatorTemplate={paginatorTemplate ? paginatorTemplate : paginatorDefaultTemplate}
      currentPageReportTemplate={currentPageReportTemplate}
      rows={rows}
      rowsPerPageOptions={rowsPerPageOptions}
      paginatorLeft={paginatorLeft}
      scrollable={scrollable}
      filterDisplay={filterDisplay}
      emptyMessage={emptyMessage}
      selection={selection}
      selectionMode={selectionMode}
      onSelectionChange={onSelectionChange}
      resizableColumns={resizableColumns}
      columnResizeMode={columnResizeMode}
      responsiveLayout={responsiveLayout}>
      {showCheckbox && <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />}
      {progressBarJobStatus}
      {columns}
      {staticColumns}
    </DataTable>
  );
};

export default DataTablePM;